import { Box as MuiBox } from '@mui/material'

interface BoxProps {
  children: React.ReactNode
  sx?: any
  style?: any
}

export const Box = (props: BoxProps) => {
  const { children, sx, style } = props

  return (
    <MuiBox sx={sx} style={style}>
      {children}
    </MuiBox>
  )
}
